import {CSSProperties} from '../../../styleSheet';
import {withCaching} from '../../../utils';
import {SizeRangeType} from '../../base/types';

const getResponsiveHideBaseStyleInternal = (
  hideWhen?: Array<SizeRangeType> | SizeRangeType,
): CSSProperties | undefined => {
  if (hideWhen === undefined) {
    return undefined;
  }

  // Resolve range
  const resolvedHideWhen = hideWhen instanceof Array ? hideWhen : [hideWhen];
  if (resolvedHideWhen.length === 0) {
    // No values, lets bail out - no style needed
    return undefined;
  }

  // Loop through ranges and create media queries
  const retVal: {[key: string]: CSSProperties} = {};

  resolvedHideWhen.forEach(r => {
    let expression = '@media screen ';
    if (r.max !== undefined) {
      expression += ` and (max-width:${r.max}px)`;
    }
    if (r.min !== undefined) {
      expression += ` and (min-width:${r.min}px)`;
    }
    retVal[expression] = {display: 'none'};
  });
  return retVal;
};

export const getResponsiveHideBaseStyle = withCaching(
  getResponsiveHideBaseStyleInternal,
);
